var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreeDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 28,
    viewBox: "0 0 7 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.58673 7.03986C1.75665 7.03986 0.273079 5.55629 0.273079 3.72621C0.273079 1.89613 1.75665 0.412552 3.58674 0.412552C5.41682 0.412552 6.90039 1.89613 6.90039 3.72621C6.90039 4.60504 6.55127 5.44789 5.92984 6.06932C5.30841 6.69075 4.46557 7.03986 3.58673 7.03986Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.58673 17.4542C1.75665 17.4542 0.273079 15.9706 0.273079 14.1406C0.273079 12.3105 1.75665 10.8269 3.58674 10.8269C5.41682 10.8269 6.90039 12.3105 6.90039 14.1406C6.90039 15.9706 5.41682 17.4542 3.58673 17.4542Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.58673 27.8686C1.75665 27.8686 0.273079 26.385 0.273079 24.5549C0.273079 22.7248 1.75665 21.2413 3.58674 21.2413C5.41682 21.2413 6.90039 22.7248 6.90039 24.5549C6.90039 26.385 5.41682 27.8686 3.58673 27.8686Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDots);
export default __webpack_public_path__ + "static/media/three-dots.a09f7ed25f288b227a736576fc2c60d8.svg";
export { ForwardRef as ReactComponent };